import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import {
  Form,
  Input,
  Button,
  Radio,
  notification,
  DatePicker,
  Modal,
  Select
} from 'antd'
import { DayPicker } from 'react-day-picker'
import { request } from '@utils'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import {
  ClockCircleFilled,
  CalendarFilled,
  DribbbleCircleFilled,
  ContactsFilled
} from '@ant-design/icons'
import 'react-day-picker/dist/style.css'
import tz from '@/utils/timezone'
import Router from 'next/router'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { useSelector } from 'react-redux'
// import Link from 'next/link'

import Detail from './detail'
import styles from './calendar.module.scss'

dayjs.extend(utc)
dayjs.extend(timezone)

// function splitTimeRange(timeRange, duration) {
//   const [start, end] = timeRange.split('-')
//   const [startHour, startMinute] = start.split(':').map(Number)
//   const [endHour, endMinute] = end.split(':').map(Number)
//   const result = []

//   for (let hour = startHour; hour < endHour; hour++) {
//     for (let minute = 0; minute < 60; minute += +duration) {
//       result.push(
//         `${hour.toString().padStart(2, '0')}:${minute
//           .toString()
//           .padStart(2, '0')}-${(hour + (minute === 30 ? 1 : 0))
//           .toString()
//           .padStart(2, '0')}:${((minute + 30) % 60)
//           .toString()
//           .padStart(2, '0')}`
//       )
//     }
//   }

//   if (endMinute >= 30) {
//     result.push(
//       `${endHour.toString().padStart(2, '0')}:00-${(endHour + 1)
//         .toString()
//         .padStart(2, '0')}:00`
//     )
//   }

//   return result
// }

const dev = process.env.NODE_ENV !== 'production'

export default function Calendar(props) {
  const [selected, setSelected] = useState()
  const [d, setd] = useState({ day: 60, description: '', number: 10 })
  const [tpl, setTpl] = useState([])
  const [spot2man, setSpot2man] = useState({})
  const [selectedTime, setSelectedTime] = useState(null)
  const [isNext, setIsNext] = useState(false)
  const [postting, setPostting] = useState(false)
  const [scheduleData, setScheduleData] = useState({})
  const [cancelReason, setCancelReason] = useState('')
  const [cancelLoading, setCancelLoading] = useState(false)
  const [childList, setChildList] = useState([])
  const [date, setDate] = useState(Date.now())
  const [timeZone, setTimeZone] = useState('America/New_York')
  const [childOpen, setChildOpen] = useState(false)
  const [showDownLoadInfo, setShowDownLoadInfo] = useState(false)
  const [powerHover, setPowerHover] = useState(false)
  const [hasChildList, setHasChildList] = useState(false)
  const [open, setOpen] = useState(false)

  const userInfo = useSelector((state) => state.auth.userInfo)

  const { query } = Router.useRouter()
  const isIframe = props.iframe
  const ref = useRef(null)
  const formRef = useRef(null)
  const selectRef = useRef(null)

  const isReset = useMemo(
    () => props.scheduleCancel || props.scheduleReset,
    [props.scheduleCancel, props.scheduleReset]
  )

  useEffect(() => {
    const tz =
      Intl.DateTimeFormat().resolvedOptions().timeZone ?? data.time_zone
    request
      .get('/api/schedule/show', {
        params: { school_id: props.id, time_zone: tz }
      })
      .then(({ data }) => {
        if (data) {
          setd(data)
          setTimeZone(tz)
          if (data && data.tpl && data.tpl.length) {
            setTpl(data.tpl)
            for (let index = 0; index < data.tpl.length; index++) {
              const { day, spot } = data.tpl[index]
              if (spot && !Array.isArray(spot)) {
                setSelected(dayjs(day).toDate())
                break
              }
            }
          }
        }
      })
  }, [date])

  useEffect(() => {
    request.get('/api/user/children').then(({ data }) => {
      setChildList(data)
      if (data && data.length) {
        setHasChildList(true)
      }
    })
  }, [props.date])

  useEffect(() => {
    if (selected) {
      const day = dayjs(selected).format('YYYY-MM-DD')
      const ctpl = tpl.filter((_) => _.day === day)
      const spot = ctpl && ctpl.length ? ctpl[0].spot : {}
      setSpot2man(spot)
    }
  }, [tpl, selected])

  // 针对取消和重选进行详情查看
  useEffect(() => {
    if (d && isReset) {
      request
        .get('/api/schedule/get', {
          params: {
            id: props.sid,
            sk: props.scheduleCancel || props.scheduleReset
          }
        })
        .then(({ data }) => {
          setScheduleData(data)
        })
    }
  }, [props.scheduleCancel, props.scheduleReset, d])

  const times = useMemo(() => {
    if (selected) {
      const day = dayjs(selected).format('YYYY-MM-DD')
      const ctpl = tpl.filter((_) => _.day === day)
      const spot = ctpl.length ? ctpl[0].spot : {}
      const spots = Object.keys(spot)
      return spots.map(
        (_) =>
          `${dayjs(
            `${dayjs().format('YYYY-MM-DD')} ${_.split('-')[0]}:00`
          ).format('HH:mm')}-${dayjs(
            `${dayjs().format('YYYY-MM-DD')} ${_.split('-')[1]}:00`
          ).format('HH:mm')}`
      )
    }
  }, [tpl, selected])

  const onFinish = (values) => {
    // setPostting(true)
    const sk = query.schedule_reset || query.schedule_cancel
    // const isUseChildList = userInfo.id ? !hasChildList : true
    request({
      url: '/api/schedule/submit',
      method: 'POST',
      data: {
        sk: sk || '',
        school_id: props.id,
        day: dayjs(selected).format('YYYY-MM-DD'),
        orig_id: props.sid || 0,
        spot: `${dayjs(
          `${dayjs().format('YYYY-MM-DD')} ${selectedTime.split('-')[0]}:00`
        ).format('HH:mm')}-${dayjs(
          `${dayjs().format('YYYY-MM-DD')} ${selectedTime.split('-')[1]}:00`
        ).format('HH:mm')}`,
        time_zone: timeZone,
        email: scheduleData.user_email,
        name: scheduleData.user_name,
        last_name: scheduleData.user_last_name,
        tel: scheduleData.user_tel,
        isIframe: isIframe ? true : '',
        ...values,
        // 判断如果未登录或未添加孩子，则使用childList
        children: isReset
          ? scheduleData.children
          : values.children
              .map((_) => {
                const item = childList.find((r) => r.id === _)
                return item
                  ? {
                      name: item.name,
                      birthday: item.birthday,
                      preferred: item.preferred
                    }
                  : null
              })
              .filter((_) => _)
      }
    })
      .then(({ code, msg }) => {
        setPostting(false)
        if (code === 0) {
          if (isIframe) {
            setShowDownLoadInfo(true)
          } else {
            notification.success({
              message: props.scheduleReset
                ? 'You have successfully modified your appointment.'
                : 'You tour has been successfully scheduled. Please check your email for the confirmation details. We are excited to meet you soon! '
              // message: (
              //   <div>
              //     <p style={{ margin: 0 }}>
              //       Appointment is successful, your appointment time is:{' '}
              //     </p>
              //     <p style={{ margin: 0 }}>
              //       <b>
              //         {selectedTime},{' '}
              //         {dayjs(selected).locale('en').format('dddd, MMMM D, YYYY')}
              //       </b>
              //     </p>
              //   </div>
              // )
            })
            props.onClose()
            if (props.scheduleReset || query.schedule) {
              window.location.href =
                window.location.origin + `/school/${query.id}`
            }
          }
        } else {
          notification.error({ message: msg })
        }
      })
      .catch((r) => {
        setPostting(false)
      })
  }

  const disabledDays = useCallback(
    (date) => {
      if (d.tpl && d.tpl.length) {
        const m = dayjs(date).format('YYYY-MM-DD')
        const arr = d.tpl.filter((_) => _.day === m)
        if (arr.length) {
          return arr[0].spot.length < 1
        } else {
          return true
        }
      }
      return (
        date < new Date(new Date().setDate(new Date().getDate() - 1)) ||
        date > new Date(new Date().setDate(new Date().getDate() + d.day))
      )
    },
    [d]
  )

  const judgeTimeDisabled = (_) => {
    const day = `${dayjs(selected).format('YYYY-MM-DD')} ${_.split('-')[0]}`
    return spot2man[_] && spot2man[_] >= d.number
      ? true
      : dayjs(day).isBefore(dayjs())
  }

  // const disabledDate = (current) => {
  //   // Can not select days before today and today
  //   return current && current < dayjs().endOf('day')
  // }

  // 取消预约
  const onCancelSchedule = () => {
    setCancelLoading(true)
    request({
      url: '/api/schedule/cancel',
      method: 'get',
      params: {
        id: props.sid,
        sk: props.scheduleCancel,
        reason: cancelReason
      }
    })
      .then((r) => {
        setCancelLoading(false)
        Modal.success({
          content: 'You have successfully cancelled the appointment.',
          onOk() {
            window.location.href =
              window.location.origin + `/school/${query.id}`
          }
        })
      })
      .catch(() => setCancelLoading(false))
  }

  const renderScheduleTime = (time) => {
    const t = time || '9:00-10:00'
    return `${dayjs(
      `${dayjs().format('YYYY-MM-DD')} ${t.split('-')[0]}:00`
    ).format('HH:mm')}-${dayjs(
      `${dayjs().format('YYYY-MM-DD')} ${t.split('-')[1]}:00`
    ).format('HH:mm')}`
  }

  /**
   * 添加children逻辑（只在iframe展示）
   */
  const modalopt = {
    open: childOpen,
    title: `Add Your Child's Info`,
    onCancel() {
      setChildOpen(false)
    },
    okText: 'Submit',
    onOk() {
      ref.current.validateFields().then((values) => {
        const id = childList.length - 1 < 0 ? 0 : childList.length
        const list = [
          ...childList,
          {
            ...values,
            id,
            preferred: dayjs(values.preferred).format('YYYY-MM-DD'),
            birthday: dayjs(values.birthday).format('YYYY-MM-DD')
          }
        ]
        setChildList(list)
        setChildOpen(false)
        let _vals = formRef.current.getFieldValue('children')
        if (!Array.isArray(_vals)) {
          _vals = _vals ? [_vals] : []
        }
        _vals.push(id)
        formRef.current.setFieldValue('children', _vals)
        ref.current.resetFields()
      })
    }
  }

  const disabledBirthdayDate = (current) => {
    // Can not select days before today and today
    return current && current > dayjs().endOf('day')
  }

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day')
  }

  const downloadPdf = () => {
    if (document) {
      const element = document.getElementById('scroll') // 这个dom元素是要导出的pdf的div容器
      const w = element.offsetWidth // 获得该容器的宽
      const h = element.offsetHeight // 获得该容器的高
      const offsetTop = element.offsetTop // 获得该容器到文档顶部的距离
      const offsetLeft = element.offsetLeft // 获得该容器到文档最左的距离
      const canvas = document.createElement('canvas')
      let abs = 0
      const win_i = document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
      const win_o = window.innerWidth // 获得当前窗口的宽度（包含滚动条）
      if (win_o > win_i) {
        abs = (win_o - win_i) / 2 // 获得滚动条宽度的一半
      }
      canvas.width = w * 2 // 将画布宽&&高放大两倍
      canvas.height = h * 2
      const context = canvas.getContext('2d')
      context.scale(2, 2)
      context.translate(-offsetLeft - abs, -offsetTop)
      // 这里默认横向没有滚动条的情况，因为offset.left()，有无滚动条的时候存在差值，因此translate的时候，要把这个差值去掉
      html2canvas(element, {
        allowTaint: true,
        scale: 2 // 提升画面质量，但是会增加文件大小
      }).then((canvas) => {
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度
        const pageHeight = (contentWidth / 592.28) * 841.89
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight
        // 页面偏移
        let position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight

        let pageDate = canvas.toDataURL('image/jpeg', 1.0)

        let pdf = new jsPDF('', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面的高度（841.89）
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageDate, 'JPEG', 0, position, imgWidth, imgHeight)
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageDate, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            // 避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }

        pdf.save(`${props.name}.pdf`)
      })
    }
  }

  const onAddChild = () => {
    setOpen(false)
    setChildOpen(true)
  }

  return (
    <div className={`${styles.main} ${isIframe ? styles.main2 : ''}`}>
      {isIframe && (
        <a
          href="https://ymontessori.com"
          target="__blank"
          className={styles.power}
          id="ym-power"
          onMouseOver={() => setPowerHover(true)}
          onMouseLeave={() => setPowerHover(false)}
        >
          {powerHover ? (
            <>
              <p>Discover More</p>
              <p>Montessori Schools</p>
            </>
          ) : (
            <>
              <p>Powered by</p>
              <p>Y Montessori</p>
            </>
          )}
        </a>
      )}
      <div className={styles.mainLeft}>
        <div className={styles.mainLeftTitle}>{props.name}</div>
        <div className={styles.mainLeftDesc}>
          <div
            dangerouslySetInnerHTML={{
              __html: d.description
                ? d.description.replace(/\n/g, '<br/>')
                : '-'
            }}
          ></div>
        </div>
        <div className={styles.mainLeftDuration}>
          <ClockCircleFilled /> {d.duration} min
        </div>
        {props.scheduleCancel && (
          <div className={styles.mainLeftTime}>
            <CalendarFilled /> {renderScheduleTime(scheduleData.time)},{' '}
            {dayjs(scheduleData.date).locale('en').format('dddd, MMMM D, YYYY')}
          </div>
        )}
        {selected && selectedTime && (
          <div className={styles.mainLeftTime}>
            <CalendarFilled /> {selectedTime},{' '}
            {dayjs(selected).locale('en').format('dddd, MMMM D, YYYY')}
          </div>
        )}
        <div className={styles.mainLeftTz}>
          <DribbbleCircleFilled /> {tz[timeZone]}
        </div>
        {selectedTime && (
          <div className={styles.mainLeftMan}>
            <ContactsFilled /> {spot2man[renderScheduleTime(selectedTime)] || 0}{' '}
            / {d.number} people
          </div>
        )}
        {props.scheduleReset && (
          <>
            <div
              className={styles.mainLeftTitle}
              style={{ marginBottom: 5, marginTop: 30, fontSize: 16 }}
            >
              Former Time
            </div>
            <div
              className={styles.mainLeftTime}
              style={{ color: '#999', textDecoration: 'line-through' }}
            >
              <CalendarFilled /> {renderScheduleTime(scheduleData.time)},{' '}
              {dayjs(scheduleData.date)
                .locale('en')
                .format('dddd, MMMM D, YYYY')}
            </div>
            <div
              className={styles.mainLeftTz}
              style={{ color: '#999', textDecoration: 'line-through' }}
            >
              <DribbbleCircleFilled /> {tz[scheduleData.time_zone]}
            </div>
          </>
        )}
      </div>
      {props.scheduleCancel ? (
        <div className={styles.mainRightCancel}>
          <h2>
            <b>Cancel Event</b>
          </h2>
          <div className={styles.mainRightCancelTitle}>
            <b>Reason for canceling</b>
          </div>
          <div className={styles.mainRightCancelContent}>
            <Input.TextArea
              rows={4}
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
            ></Input.TextArea>
          </div>
          <div className={styles.mainRightCancelBtn}>
            <Button
              type="primary"
              onClick={onCancelSchedule}
              disabled={!cancelReason || scheduleData.status !== 1}
              loading={cancelLoading}
            >
              {scheduleData.status === 0 ? 'Unable Cancel' : 'Cancel Event'}
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles.mainRight}>
          {showDownLoadInfo ? (
            <>
              <div className={styles.pdf}>
                <Detail url={props.id} showNote />
              </div>
              <div className={styles.info}>
                <p>
                  Thank You for Scheduling a Tour!
                  <br />
                  Tired of Keeping Track of School Details?
                  <br />
                  Download Our School Information Summary,Complete with a Handy
                  Notes Section!
                </p>
                <Button type="primary" onClick={downloadPdf}>
                  DownLoad PDF
                </Button>
              </div>
            </>
          ) : (
            <>
              <div
                style={{ display: isNext ? 'block' : 'none', width: '100%' }}
              >
                <div className={styles.mainRightForm}>
                  <div className={styles.mainRightFormTitle}>Enter Details</div>
                  <Modal {...modalopt}>
                    <Form
                      ref={ref}
                      name="basic"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      style={{ maxWidth: 600 }}
                      initialValues={{ remember: true }}
                      autoComplete="off"
                    >
                      <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: 'Please input children name!'
                          }
                        ]}
                      >
                        <Input style={{ width: 230 }} />
                      </Form.Item>

                      {/* <Form.Item
                      label="Full Name"
                      name="full_name"
                      rules={[
                        { required: true, message: 'Please input children Full Name!' }
                      ]}
                    >
                      <Input style={{ width: 230 }} />
                    </Form.Item> */}

                      <Form.Item
                        label="gender"
                        name="sex"
                        rules={[
                          {
                            required: true,
                            message: 'Please select children gender!'
                          }
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={1}>Boy</Radio>
                          <Radio value={2}>Girl</Radio>
                        </Radio.Group>
                      </Form.Item>

                      <Form.Item
                        label="Birthday"
                        name="birthday"
                        rules={[
                          {
                            required: true,
                            message: 'Please select children birthday!'
                          }
                        ]}
                      >
                        <DatePicker
                          style={{ width: 230 }}
                          disabledDate={disabledBirthdayDate}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Expected Start Day"
                        name="preferred"
                        rules={[
                          {
                            required: true,
                            message:
                              'Please select children Expected Start Day!'
                          }
                        ]}
                      >
                        <DatePicker
                          style={{ width: 230 }}
                          disabledDate={disabledDate}
                        />
                      </Form.Item>
                    </Form>
                  </Modal>
                  <Form
                    ref={formRef}
                    layout="vertical"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 24 }}
                    style={{ maxWidth: 600 }}
                    onFinish={onFinish}
                    autoComplete="off"
                  >
                    {props.scheduleReset ? (
                      <>
                        <Form.Item label="Reason for change" name="reason">
                          <Input.TextArea rows={4} />
                        </Form.Item>
                      </>
                    ) : (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                        >
                          <Form.Item
                            label="First Name"
                            name="name"
                            style={{ width: '48%' }}
                            rules={[
                              {
                                required: true,
                                message: 'Please input your First Name!'
                              }
                            ]}
                          >
                            <Input size="large" />
                          </Form.Item>
                          <Form.Item
                            label="Last Name"
                            name="last_name"
                            style={{ width: '48%' }}
                            rules={[
                              {
                                required: true,
                                message: 'Please input your Last Name!'
                              }
                            ]}
                          >
                            <Input size="large" />
                          </Form.Item>
                        </div>

                        <Form.Item
                          label="Email"
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: 'Please input your email!'
                            },
                            {
                              required: true,
                              type: 'email',
                              message: 'Please enter a correct email address!'
                            }
                          ]}
                        >
                          <Input size="large" />
                        </Form.Item>

                        <Form.Item
                          label="Phone Number"
                          name="tel"
                          rules={[
                            {
                              len: 10
                            }
                          ]}
                        >
                          <Input
                            type="number"
                            maxLength={10}
                            size="large"
                            addonBefore="+1"
                          />
                        </Form.Item>

                        <Form.Item
                          label="Name(s)of Child(ren)"
                          name="children"
                          rules={[
                            {
                              required: true,
                              message: 'Please select your children name!'
                            }
                          ]}
                        >
                          <Select
                            ref={selectRef}
                            mode="multiple"
                            style={{ width: '100%' }}
                            className={styles.select}
                            placeholder="Please select your children name!"
                            open={open}
                            onDropdownVisibleChange={(visible) =>
                              setOpen(visible)
                            }
                            dropdownRender={(menu) => (
                              <>
                                {menu}
                                <div
                                  style={{
                                    textAlign: 'center',
                                    padding: '10px 0'
                                  }}
                                >
                                  {isIframe ? (
                                    <a onClick={onAddChild}>
                                      + add your child’s info
                                    </a>
                                  ) : (
                                    <a href="/aboutme" target="__blank">
                                      + add your child’s info
                                    </a>
                                  )}
                                </div>
                              </>
                            )}
                            optionLabelProp="label"
                          >
                            {childList.map((_) => (
                              <Select.Option
                                value={_.id}
                                key={_.id}
                                label={_.name}
                              >
                                <div>
                                  <h6
                                    style={{
                                      fontSize: 18,
                                      marginBottom: 2,
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {_.name}
                                  </h6>
                                  <p style={{ margin: 0, color: '#888' }}>
                                    {_.name}'s birthday is <b>{_.birthday}</b>,
                                    the expected start date is{' '}
                                    <b>{_.preferred}</b>
                                  </p>
                                </div>
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        {/* <Form.Item
                        label="Dates of Birth of Children"
                        name="children_birthday"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your children birthday!'
                          }
                        ]}
                      >
                        <DatePicker style={{ width: '100%' }} placeholder="" />
                      </Form.Item>

                      <Form.Item
                        label="Preferred Start Date"
                        name="preferred_start_day"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your Preferred Start Date!'
                          }
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          disabledDate={disabledDate}
                          placeholder=""
                        />
                      </Form.Item> */}
                      </>
                    )}
                    <div className={styles.mainRightBtn}>
                      <Button
                        style={{ marginRight: 20 }}
                        onClick={() => setIsNext(false)}
                      >
                        Previous Step
                      </Button>
                      <Button
                        htmlType="submit"
                        type="primary"
                        loading={postting}
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div
                className={styles.mainRightPickerBox}
                style={{
                  display: !isNext ? 'flex' : 'none'
                }}
              >
                <div className={styles.mainRightPicker}>
                  <DayPicker
                    disabled={disabledDays}
                    toMonth={
                      new Date(new Date().setMonth(new Date().getMonth() + 2))
                    }
                    fromMonth={new Date()}
                    numberOfMonths={1}
                    min={1}
                    mode="single"
                    selected={selected}
                    onSelect={setSelected}
                  />
                </div>
                <div className={styles.mainRightTime}>
                  {selected && (
                    <div className={styles.mainRightTimeTitle}>
                      {dayjs(selected).locale('en').format('dddd, MMMM D')}
                    </div>
                  )}
                  <div className={styles.mainRightTimeItems}>
                    <div className={styles.mainRightTimeItem}>
                      <Radio.Group
                        value={selectedTime}
                        onChange={(e) => setSelectedTime(e.target.value)}
                        buttonStyle="solid"
                      >
                        {times &&
                          times.map((_) => (
                            <Radio.Button
                              value={_}
                              key={_}
                              disabled={judgeTimeDisabled(_)}
                            >
                              {_}
                              {spot2man[_] && spot2man[_] >= d.number ? (
                                <span style={{ color: '#999', paddingLeft: 5 }}>
                                  (full)
                                </span>
                              ) : (
                                ''
                              )}
                            </Radio.Button>
                          ))}
                      </Radio.Group>
                    </div>
                  </div>
                </div>
                <div style={{ width: '100%', textAlign: 'right' }}>
                  <Button
                    onClick={() => setIsNext(true)}
                    disabled={
                      !selected ||
                      !selectedTime ||
                      (scheduleData.id && scheduleData.status !== 1)
                    }
                    type="primary"
                    style={{ marginRight: 44 }}
                  >
                    Next Step
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}
